module.exports = __webpack_public_path__ + "img/UAVsystem2.644099dc.jpg";